export const ADD_TO_WISH = "ADD_TO_WISH";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_ITEM_WISH = "REMOVE_ITEM_WISH";
export const REMOVE_ITEM_CART = "REMOVE_ITEM_CART";
export const CLEAR_CART = "CLEAR_CART";
export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";
export const GET_TOTAL = "GET_TOTAL";
